var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsChevronLeft = function SvgIconsChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.317 15.78c.244.28.244.732 0 1.01-.224.256-.575.278-.82.065l-.064-.064-3.75-4.286c-.224-.256-.242-.657-.056-.937l.056-.073 3.75-4.286c.244-.279.64-.279.884 0 .224.256.242.657.056.937l-.056.073L11.009 12l3.308 3.78z"
  })));
};
export default SvgIconsChevronLeft;